import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const navItems = [
  { label: 'Home', id: 'hero' },
  { label: 'Products & Services', id: 'products-services' },
  { label: 'Technology Partners', id: 'partners' },
  { label: 'Our Clients', id: 'clients' },
  { label: 'Contact', id: 'contact' }];


  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white shadow-lg' 
        : 'bg-white shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <div className={`!font-bold !text-2xl transition-colors duration-300 ${
              scrolled ? 'text-[#1e3a8a]' : 'text-[#1e3a8a]'
            }`}>Brahmaputra Infotech

            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) =>
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`font-medium transition-colors duration-200 ${
                scrolled 
                  ? 'text-gray-700 hover:text-[#1e3a8a]' 
                  : 'text-gray-700 hover:text-[#1e3a8a]'
              }`}>

                {item.label}
              </button>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>

            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen &&
      <div className="md:hidden bg-white border-t">
          <nav className="px-4 py-4 space-y-3">
            {navItems.map((item) =>
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-md transition-colors duration-200">

                {item.label}
              </button>
          )}
          </nav>
        </div>
      }
    </header>);

};